import { render, staticRenderFns } from "./NsFooter.vue?vue&type=template&id=bfce8a2e&scoped=true&"
import script from "./NsFooter.vue?vue&type=script&lang=js&"
export * from "./NsFooter.vue?vue&type=script&lang=js&"
import style0 from "./NsFooter.vue?vue&type=style&index=0&id=bfce8a2e&scoped=true&lang=css&"
import style1 from "./NsFooter.vue?vue&type=style&index=1&id=bfce8a2e&scoped=true&lang=scss&"
import style2 from "./NsFooter.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfce8a2e",
  null
  
)

export default component.exports